import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-member",
  "use": "icon-member-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1000 1000\" id=\"icon-member\"><path d=\"M261.8,843.1h476.5c20.3,0,36.8,16.5,36.8,36.8c0,20.3-16.5,36.8-36.8,36.8H261.8c-20.3,0-36.8-16.5-36.8-36.8\n  C225,859.6,241.5,843.1,261.8,843.1z M923.3,424.9L783.4,760c-8.6,20.7-28.9,34.1-51.3,34.1H267.9c-22.4,0-42.6-13.5-51.3-34.1\n  L78.5,429.3c-5.1,1.3-10.5,2-16,2C28,431.4,0,403.9,0,370.1c0-33.8,28-61.3,62.5-61.3s62.5,27.4,62.5,61.3c0,8.8-1.9,17.1-5.3,24.7\n  l212.1,102.4L467.3,223c-25-11.9-42.3-37.1-42.3-66.2c0-40.6,33.6-73.5,75-73.5s75,32.9,75,73.5c0,29.2-17.4,54.5-42.6,66.3\n  L664,492.3l217.5-99.8c-4.2-8.2-6.5-17.5-6.5-27.3c0-33.8,28-61.3,62.5-61.3s62.5,27.4,62.5,61.3c0,33.8-28,61.3-62.5,61.3\n  C932.6,426.5,927.9,425.9,923.3,424.9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/member.svg
// module id = jiW9
// module chunks = 28